import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/shared/api/client'
import { queryKeys } from '@/shared/api/queryKeys'
import { toast } from '@/shared/model/toast'
import { ApiError } from '@/shared/api/client'
import type { VoiceSettings } from '@/shared/api/types'

export const voiceApi = {
  get: (signal?: AbortSignal) => api.get<VoiceSettings>('/voice', signal),
  save: (patch: Partial<VoiceSettings>) => api.put<VoiceSettings>('/voice', patch),
}

export function useVoiceSettings() {
  return useQuery({
    queryKey: queryKeys.voice,
    queryFn: ({ signal }) => voiceApi.get(signal),
  })
}

export function useSaveVoice() {
  const queryClient = useQueryClient()

  return useMutation({
    // Отправляется только изменённое: сервер накладывает присланные поля
    // на текущие. Слать всю структуру опаснее — форма, отставшая от
    // новой версии API, затёрла бы поля, о которых не знает.
    mutationFn: (patch: Partial<VoiceSettings>) => voiceApi.save(patch),
    onSuccess: (saved) => {
      queryClient.setQueryData(queryKeys.voice, saved)
      toast.success('Настройки голоса сохранены')
    },
    onError: (error) => {
      toast.error(error instanceof ApiError ? error.message : 'Не удалось сохранить')
    },
  })
}
